import { render, staticRenderFns } from "./PetHealthTypeWeightForm.vue?vue&type=template&id=6356c338&"
import script from "./PetHealthTypeWeightForm.vue?vue&type=script&lang=js&"
export * from "./PetHealthTypeWeightForm.vue?vue&type=script&lang=js&"
import style0 from "./PetHealthTypeWeightForm.vue?vue&type=style&index=0&id=6356c338&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports